module.exports = __webpack_public_path__ + "img/pdf.9320c29e.svg";